import React from 'react';
import { Package } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

// Columnas y exportación de alistamientos compartidas entre AlistamientosPage y el
// reporte "Alistamientos" del Reporte 360 v2.

export const getEstadoBadge = (estado) => {
  const estados = {
    'Pendiente': 'bg-yellow-100 text-yellow-800',
    'Alistado': 'bg-purple-100 text-purple-800',
    'En Ruta': 'bg-blue-100 text-blue-800',
    'Entregado': 'bg-green-100 text-green-800',
    'Cancelado': 'bg-red-100 text-red-800',
  };
  return estados[estado] || 'bg-gray-100 text-gray-800';
};

// Columnas de datos de la tabla (sin la columna de acciones, que depende de cada página)
export const alistamientosDataColumns = [
  {
    id: 'estado',
    label: 'Estado',
    render: (row) => (
      <Badge className={getEstadoBadge(row.estado)}>
        {row.estado}
      </Badge>
    ),
  },
  {
    id: 'consecutivo',
    label: 'Consecutivo',
    render: (row) => (
      <span className="font-semibold text-purple-600">{row.consecutivo}</span>
    ),
  },
  {
    id: 'cliente',
    label: 'Cliente',
    render: (row) => (
      <div>
        <div className="font-medium">{row.cliente.nombre}</div>
        <div className="text-xs text-gray-500">{row.cliente.direccion || 'Sin dirección'}</div>
      </div>
    ),
  },
  {
    id: 'alistador',
    label: 'Alistador',
    render: (row) => (
      <span className="text-sm">{row.alistador.nombre.toUpperCase()}</span>
    ),
  },
  {
    id: 'bolsas',
    label: 'Bolsas',
    render: (row) => (
      <div className="flex items-center gap-1">
        <Package className="h-4 w-4 text-gray-400" />
        <span>{row.bolsas?.length || 0}</span>
      </div>
    ),
  },
  {
    id: 'totalItems',
    label: 'Total Items',
    render: (row) => (
      <span className="font-medium">{row.totalItems}</span>
    ),
  },
  {
    id: 'pesoTotal',
    label: 'Peso Total',
    render: (row) => (
      <span className="text-sm">{row.pesoTotal}g</span>
    ),
  },
  {
    id: 'fechaCreacion',
    label: 'Fecha',
    render: (row) => (
      <span className="text-sm">
        {new Date(row.fechaCreacion).toLocaleDateString('es-ES')}
      </span>
    ),
  },
];

// Columnas para Excel (una fila por item)
export const alistamientosExcelColumns = [
  { key: 'consecutivo', header: 'Consecutivo' },
  { key: 'cliente.nombre', header: 'Cliente' },
  { key: 'cliente.direccion', header: 'Dirección' },
  { key: 'alistador.nombre', header: 'Alistador' },
  { key: 'zona', header: 'Zona' },
  { key: 'estado', header: 'Estado' },
  { key: '_item.bolsa', header: 'Bolsa #' },
  { key: '_item.nombre', header: 'Prenda' },
  { key: '_item.cantidad', header: 'Cantidad' },
  { key: '_item.peso', header: 'Peso Unitario (g)' },
  {
    key: '_item.cantidad',
    header: 'Peso Total Item (g)',
    transform: (value, row) => (value || 0) * (row?._item?.peso || 0),
  },
  {
    key: 'fechaCreacion',
    header: 'Fecha de Creación',
    transform: (value) => {
      if (!value) return '';
      try {
        const d = new Date(value);
        if (isNaN(d.getTime())) return '';
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');
        const seconds = String(d.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      } catch (_) {
        return '';
      }
    },
  },
  { key: 'observaciones', header: 'Observaciones' },
];

// Expande cada alistamiento en una fila por item (formato del Excel)
export const expandAlistamientosPorItem = (alistamientos = []) => {
  const rows = [];
  alistamientos.forEach((alistamiento) => {
    const items = alistamiento.items;
    if (items && items.length > 0) {
      items.forEach((item) => {
        rows.push({ ...alistamiento, _item: item });
      });
    } else {
      rows.push({ ...alistamiento, _item: {} });
    }
  });
  return rows;
};
